import CvDataForm from './CvDataForm';

export default CvDataForm;
